import React from "react";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-16"
        >
          <div className="lg:col-span-6">
            <div className="mb-4 flex items-center gap-3">
              <div className="h-px w-8 bg-[var(--gold)]/60" />
              <span className="font-mono-label text-[var(--gold)]">
                02 · About HR Enterprises
              </span>
            </div>
            <h2 className="font-display text-4xl leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
              We don&apos;t<br />
              <span className="font-serif-display italic gold-gradient-text">
                chase trends.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-6">
            <p className="text-[18px] leading-relaxed text-zinc-200">
              We build businesses that stay relevant.
            </p>
            <p className="mt-5 text-[15px] leading-relaxed text-zinc-400">
              Every project is crafted with strategy, technology, creativity
              and growth in mind. Because your brand deserves more than another
              template.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-3">
              {[
                { k: "Strategy" },
                { k: "Technology" },
                { k: "Creativity" },
                { k: "Growth" },
              ].map((p, i) => (
                <div
                  key={p.k}
                  className="rounded-xl border border-white/[0.06] bg-[#0e0e10] p-4"
                >
                  <div className="font-mono-label text-zinc-500">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="mt-2 font-display text-lg font-semibold text-white">
                    {p.k}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
